module.exports = __webpack_public_path__ + "media/images/version_merge/banks/napas_logo-0b9e35eaf2e81631f44c4abd0010dae7.png";